__turbopack_context__.v({
  "brand": "AuthGate-module__oOCr9a__brand",
  "copy": "AuthGate-module__oOCr9a__copy",
  "error": "AuthGate-module__oOCr9a__error",
  "form": "AuthGate-module__oOCr9a__form",
  "loadingPage": "AuthGate-module__oOCr9a__loadingPage",
  "page": "AuthGate-module__oOCr9a__page",
  "panel": "AuthGate-module__oOCr9a__panel",
  "submit": "AuthGate-module__oOCr9a__submit",
});
